import ColourNoneIcon from '@atlaskit/icon-lab/core/colour-none';
import * as React from 'react';

export function SvgColorNone() {
  return <ColourNoneIcon label="" testId="ads-refreshed-icon" />;
}
